import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  contentContainer: {
    padding: theme.spacing(2, 2, 2.5),
    borderRadius: theme.spacing(1),
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: theme.spacing(1),
      backgroundColor: 'rgba(0, 0, 0, 0)',
      transition: 'background-color 0.2s ease'
    }
  },
  hoverable: {
    '&:hover::before, &:focus-within::before': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  title: {
    ...theme.typography.body1,
    color: theme.palette.text.primary
  },
  value: {
    ...theme.typography.h6,
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
  }
}));

export const ActionItemContent = ({
  classes: classesOverrides,
  actionTitle,
  actionValue,
  actionClassName,
  isLoading,
  children
}) => {
  const classes = useStyles({ classes: classesOverrides });

  return (
    <div
      className={classNames(classes.contentContainer, actionClassName, {
        [classes.hoverable]: Boolean(children)
      })}
    >
      <Typography className={classes.title} data-qe-id="actionItemTitle">
        {actionTitle}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" height={30} width={120} />
      ) : (
        <Typography className={classes.value} data-qe-id="actionItemValue">
          {actionValue}
        </Typography>
      )}
      {children}
    </div>
  );
};

ActionItemContent.propTypes = {
  classes: PropTypes.object,
  actionTitle: PropTypes.string,
  actionValue: PropTypes.string,
  actionClassName: PropTypes.string,
  isLoading: PropTypes.bool,
  children: PropTypes.node
};

export default ActionItemContent;
